import { Component, OnInit } from '@angular/core';
import { ValidationResultService } from '../../services';
import { ValidationErrorPopupState } from '../../interfaces';
import { ValidationError, ValidationResult } from '../../models';

@Component({
  selector: 'app-validation-result',
  templateUrl: './validation-result.component.html',
  styleUrl: './validation-result.component.scss',
})
export class ValidationResultComponent implements OnInit {
  vm: ValidationErrorPopupState = { visible: false };
  constructor(private service: ValidationResultService) {}

  ngOnInit(): void {
    this.service.state$.subscribe((s) => {
      this.vm = {
        visible: s.visible,
        message: (s.message as ValidationResult) ?? new ValidationResult(),
      };
    });
  }

  get errorCount() {
    return this.count(0);
  }
  get warningCount() {
    return this.count(1);
  }
  get infoCount() {
    return this.count(2);
  }

  private count(kind: ValidationError['severity']) {
    return (this.vm.message?.errors ?? []).filter((e) => e.severity === kind)
      .length;
  }

  badgeColor(sev: ValidationError['severity']) {
    switch (sev) {
      case 0:
        return 'error-bg';
      case 1:
        return 'warning-bg';
      case 2:
        return 'info-bg';
    }
  }

  hide() {
    this.service.hide();
  }
}
